import { useMemo } from 'react'
import {
    ApiBrandBenefit,
    ApiLandingPageBannerBenefit,
} from '@storefronts/common-types'

/**
 * Shared hook for computing benefits texts from banner text, banner benefits, and brand benefits.
 * Used across multiple components that display rotating or scrolling benefits.
 *
 * @param bannerText - Optional banner text string
 * @param bannerBenefits - Array of landing page banner benefits
 * @param brandBenefits - Array of brand benefits
 * @returns Array of benefit description strings
 */
export const useBenefitsTexts = (
    bannerText?: string,
    bannerBenefits: ApiLandingPageBannerBenefit[] = [],
    brandBenefits: ApiBrandBenefit[] = [],
): string[] => {
    return useMemo(() => {
        const brandBenefitAccountBanners = brandBenefits.filter(
            (bb) => bb.isAccountBanner,
        )
        return (bannerText ? [bannerText] : [])
            .concat(brandBenefitAccountBanners.map((bb) => bb.description))
            .concat(
                bannerBenefits
                    .filter(
                        (bb) =>
                            bb.isActive &&
                            !brandBenefitAccountBanners.some(
                                (b) => b.id === bb.brandBenefitId,
                            ),
                    )
                    .map((bb) => bb.description)
                    .filter((description) => description != null),
            )
    }, [bannerText, bannerBenefits, brandBenefits])
}
